import React from "react";
export const TierInstrument = ({ name, iconUrl }) => (React.createElement("span", { className: "tier-instrument" },
    React.createElement("img", { src: iconUrl }),
    React.createElement("span", { className: "tier-instrument__name" }, name)));
